<img [height]="height()"
     [ngSrc]="blackWineglass() ? 'https://a.storyblok.com/f/106593/206x400/1927c37bb0/trist-vinglas-sort.png' : 'https://a.storyblok.com/f/106593/600x600/018e188df6/sad-empty-wineglass.png'"
     [width]="width()"
     class="empty-cart-image">
<div class="d-flex flex-column">
  <p>{{ text() }}</p>
  @if (buttonText()) {
    <button (click)="buttonClick.emit()" class="btn btn-primary">{{ buttonText() }}</button>
  }
</div>
